import { action, makeObservable, observable } from 'mobx';
import React, { Suspense } from 'react';

import { ErrorBoundary, SkeletonCard, injectStores, componentFromLazy, ViewportCardProvider } from "@intrasync/react";
// import RootStore from '@intrasync/stores';
import { RouteType } from 'types/RouteType';
import type { RouterStore } from '@intrasync/stores';

// const lazyFromComp = (
//   component: Promise<{ default: React.ComponentType<any> }>
// ): React.LazyExoticComponent<React.ComponentType<any>> => {
//   const Component = lazy(() => component);
//   return Component;
// };
// const lazyFromFuncComp = (
//   component: () => Promise<{ default: React.ComponentType<any> }>
// ): React.LazyExoticComponent<React.ComponentType<any>> => {
//   const Component = lazy(component);
//   return Component;
// };
// let componentCache = {};

// interface Route {
//   key: string;
//   component:
//     | React.ComponentType<any>
//     | (() => Promise<{ default: React.ComponentType<any> }>)
//     | Promise<{ default: React.ComponentType<any> }>;
// }

interface ComponentRouterProps {
  routerStore?: RouterStore;
}

class ComponentRouter extends React.PureComponent<ComponentRouterProps> {
  loadedComponents: {
    [key: string]: React.ComponentType<ComponentRouterProps>;
  } = {};

  constructor(props: ComponentRouterProps) {
    super(props);
    makeObservable(this, {
      loadedComponents: observable,
      setLoadedComponents: action,
      // renderComp: computed,
      // renderCompName: computed,
    });
  }
  setLoadedComponents = (
    routeName: string,
    comp: React.ComponentType<ComponentRouterProps>
  ): void => {
    this.loadedComponents[routeName] = comp;
    // console.log(`Saved ${routeName} to cache`);
    // console.log(`Cache Length: ${Object.keys(this.loadedComponents).length}`);
  };
  lazyComponent = (
    currentRoute: RouteType
  ):
    | React.ComponentType<ComponentRouterProps>
    | React.LazyExoticComponent<React.ComponentType<ComponentRouterProps>> => {
    if (
      typeof currentRoute.component === 'function' ||
      (currentRoute.component &&
        typeof (
          currentRoute.component as Promise<{
            default: React.ComponentType<unknown>;
          }>
        ).then === 'function')
    ) {
      return componentFromLazy(
        currentRoute.component as
          | Promise<{ default: React.ComponentType<unknown> }>
          | (() => Promise<{ default: React.ComponentType<unknown> }>)
      );
    }
    return currentRoute.component as unknown as React.ComponentType<unknown>;
  };

  // get renderComp() {
  //   const { routerStore } = this.props;
  //   const currentRoute = routerStore?.currentRoute;
  //   if (!currentRoute) return false;
  //   const currentComponent = currentRoute.component;
  //   if (!currentComponent) return false;
  //   return true;
  // }

  // get renderCompName() {
  //   const { routerStore } = this.props;
  //   const currentRoute = routerStore?.currentRoute;
  //   if (!currentRoute?.key) return '';
  //   return `-${currentRoute.key}`;
  // }
  render() {
    const { routerStore } = this.props;
    const currentRoute = routerStore?.currentRoute;
    const currentPath = routerStore?.currentPath;
    if (currentRoute && currentRoute.viewportCard) {
      return <ViewportCardProvider />;
    }

    if (
      currentRoute &&
      currentRoute.key &&
      !this.loadedComponents[currentRoute.key]
    ) {
      const currentRouteName = `-${currentRoute.key}`;
      // console.log(`Setting up ${currentRouteName}`);
      const Component = this.lazyComponent(
        currentRoute
      ) as React.ComponentType<unknown>;
      // console.log(`Component ${currentRouteName} loaded`);
      const currentComponentLoaded = () => (
        <Suspense fallback={<SkeletonCard />}>
          <ErrorBoundary
            key={currentPath}
            name={`ComponentRouter${currentRouteName}`}
            isLayout={true}
          >
            <Component />
          </ErrorBoundary>
        </Suspense>
      );
      // componentCache[currentRoute.key] = currentComponentLoaded;
      this.setLoadedComponents(currentRoute.key, currentComponentLoaded);

      return currentComponentLoaded();
    }
    const loaded =
      currentRoute && currentRoute.key
        ? this.loadedComponents[currentRoute.key]
        : undefined;
    // console.log(`Loaded ${currentRoute.key} from cache`);
    const LoadedComponent = loaded;
    return LoadedComponent ? <LoadedComponent {...this.props} /> : null;
  }
}

export default injectStores(ComponentRouter);
